import { Layout } from '../types';

export function copyLayout(layout: Layout): Layout {
	return layout.map(innerArray => [...innerArray]);
}
